import { ReactNode, useState } from 'react'

import { AuthContext, INITIAL_STATE, AuthState } from './authContext'

interface Props {
  children: ReactNode,
  state?: AuthState
}

export const AuthProvider = ({ children, state }: Props) => {
  const [isWebinarAdmin, setIsWebinarAdmin] = useState(INITIAL_STATE.isWebinarAdmin)
  const [isContentEditor, setIsContentEditor] = useState(INITIAL_STATE.isContentEditor)
  const [isModerator, setIsModerator] = useState(INITIAL_STATE.isModerator)

  return (
    <AuthContext.Provider value={{
      isWebinarAdmin,
      setIsWebinarAdmin,
      isContentEditor,
      setIsContentEditor,
      isModerator,
      setIsModerator,
      ...state
    }}>
      {children}
    </AuthContext.Provider>
  )
}
